import React, {Fragment, useEffect, useRef, useState} from 'react';
import {Alert, Button, Card, CardBody, CardFooter, CardHeader, CardText, Col, Row, Spinner} from "reactstrap";
import {ArrowLeft, ArrowRight, Check, CheckCircle, CreditCard, RefreshCw, User, XCircle} from "react-feather";
import Webcam from "react-webcam";
import * as faceapi from 'face-api.js/dist/face-api'

import exampleFace from "@src/assets/images/examples/face.png"
// import exampleFaceDocument from "@src/assets/images/examples/face_document.png"
import exampleFaceDocument from "@src/assets/images/examples/document_face.png"
import exampleFaceDocumentBehind from "@src/assets/images/examples/document_behind.png"
import axios from "axios";
import toast from "react-hot-toast";
import styles from "../styles.module.scss";
import CheckPermission from '../CheckPermission'

const IdentityRecognition = ({userToRegister, onFinish, ids, stepper, client}) => {

    const [loading, setLoading] = useState(false);
    const [verified, setVerified] = useState(false);
    const [error, setError] = useState(null);

    const [hasCameraPermission, setHasCameraPermission] = useState(false)

    const webcamRef = useRef(null);
    const camDocRef = useRef(null);
    const camDocBehRef = useRef(null);

    const [imageFace, setImageFace] = useState(null);
    const [imageFaceScore, setImageFaceScore] = useState(0);

    const [imageDocument, setImageDocument] = useState(null);
    const [imageDocumentBehind, setImageDocumentBehind] = useState(null);

    const checkPermissions = async () => {
        try {
          const permission = await navigator.permissions.query({ name: 'camera' })
          // console.log(permission);
          setHasCameraPermission(permission.state === 'granted')
          return permission.state === 'granted'
        } catch (error) {
          setHasCameraPermission(false)
          return false
        }
      }

    const loadFaceApi = async () => {
        await Promise.all([
            faceapi.nets.ssdMobilenetv1.loadFromUri('/models'),
            faceapi.nets.tinyFaceDetector.loadFromUri('/models'),
            faceapi.nets.faceLandmark68Net.loadFromUri('/models'),
            faceapi.nets.faceRecognitionNet.loadFromUri('/models')
        ]);
    }

    useEffect(() => {
        loadFaceApi()
    }, []);


    useEffect(() => {
        if (imageFace) {
            setLoading(true);
            recognizeFace();
            setLoading(false);
        }
    }, [imageFace]);


    const recognizeFace = async () => {
        // if (!hasCameraPermission) return
        const image = document.getElementById('faceImage');
        const detection = await faceapi.detectSingleFace(image).withFaceLandmarks().withFaceDescriptor();

        if (detection?.alignedRect?.score) {
            setImageFaceScore((detection.alignedRect.score * 100))
        } else {
            setImageFaceScore(0);
        }

    }

    const videoConstraints = {
        width: 800,
        height: 600,
        facingMode: 'user',
        brightness: 100 // ajustar aquí el valor de brillo
    };

    const capture = () => {
        // if (!isBlockedByBrowser) requestCameraPermission()
        const imageFace = webcamRef.current.getScreenshot();
        setImageFace(imageFace);
    };

    const captureDocument = () => {
        // if (!isBlockedByBrowser) requestCameraPermission()
        const imageDocument = camDocRef.current.getScreenshot();
        setImageDocument(imageDocument);
    };

    const captureDocumentBehind = () => {
        // if (!isBlockedByBrowser) requestCameraPermission()
        const imageDocumentBehind = camDocBehRef.current.getScreenshot();
        setImageDocumentBehind(imageDocumentBehind);
    };
    const verifiedAction = async () => {

        try {
            setLoading(true);

            const resultUploadImages = await axios.post(`${process.env.REACT_APP_API_NODE_URL}/upload/life/images`, {
                company_name: client,
                imageFaceName: `${userToRegister.documentNumber}-face`,
                imageFace,
                imageDocumentName: `${userToRegister.documentNumber}-document`,
                imageDocument,
                imageDocumentBehindName: `${userToRegister.documentNumber}-document-behind`,
                imageDocumentBehind,
            });

            if (resultUploadImages.data) {
                const sendLifeTests = [
                    axios.post(
                        `${process.env.REACT_APP_API_URL}/clients/saveLifeTest`,
                        {
                            url: resultUploadImages.data.imageFaceUrl,
                            clientId: 13
                        }),
                    axios.post(
                        `${process.env.REACT_APP_API_URL}/clients/saveLifeTest`,
                        {
                            url: resultUploadImages.data.imageDocumentUrl,
                            clientId: 13
                        })
                ];
                await Promise.all(sendLifeTests);

                // consumir endpoint de registro de usuario
                console.log(userToRegister);
                const clientResult = await axios.post(`${process.env.REACT_APP_API_URL}/clients`, {
                    firtsName: userToRegister.firstName,
                    lastName: userToRegister.lastName,
                    phone: userToRegister.phoneNumber,
                    email: userToRegister.email,
                    identificationNumber: userToRegister.identificationNumber,
                    identificationTypeId: userToRegister.identificationType
                });

                localStorage.removeItem('dataOTP');
                localStorage.removeItem('typeOTP');
                localStorage.setItem(`tyc-showed`, ids);
                localStorage.setItem(`client-data`, JSON.stringify(clientResult.data));
                setLoading(false);
                onFinish();
            } else {
                toast.error('Error al cargar las imagenes a S3')
            }
        } catch (e) {
            console.error(e);
            toast.error(`Ha ocurrido un error inesperado: ${e.response.data.title}`);
        }


    }

    useEffect(() => {
        checkPermissions()
    }, [])


    return (
        <React.Fragment>
            {hasCameraPermission && (
                <div className='col-lg-8 col-md-12 col-sm-12 py-4 m-auto'>
                <Card className={'px-3 py-3'}>
                    <CardHeader>
                        <h2 className="brand-text mb-0 text-primary">RubriDoc</h2>
                        <span className="float-end">Prueba de vida 1</span>
                    </CardHeader>
                    <CardBody className={'pb-0'}>
                        <hr/>

                        {loading && <div className='row'>
                            <div className='col-12 px-2 py-4 text-center'>
                                <Spinner size='lg'/>
                                <CardText className={'py-1 fs-5'}>Enviando pruebas ...</CardText>
                            </div>
                        </div>
                        }

                        {!loading && !error && verified && <div className='row'>
                            <div className='col-12 px-2 text-center'>
                                <Alert color='success'>
                                    <div className='alert-body py-3'>
                                        <CheckCircle size={32}/>
                                        <h3 className='text-success pt-2'>
                                            Prueba de vida verificada!
                                        </h3>
                                    </div>
                                </Alert>
                            </div>
                        </div>
                        }
    
                        {!loading && !verified && !error && (<Fragment>
                            <Col lg={{ size: 12, order: 0 }} md={{ size: 12, order: 0 }} xs={{ size: 12, order: 0 }}
                                 className={'text-center pt-2'}>
                                <h3>Prueba de vida</h3>
                            </Col>
    
                            <Row>
                                <Col lg={{size: 12, order: 0}} md={{size: 12, order: 0}} xs={{size: 12, order: 0}}
                                     className={'pt-1 text-center'}>
    
                                    <span className={'pb-2 fs-4 d-block fw-bold'}>
                                      1. Habilita la cámara de tu dispositivo y toma una fotografía frontal, colócate frente a la cámara como se muestra en la imagen ejemplo y oprime  <strong>Capturar foto facial </strong> </span>
    
    
                                    <Row>
                                        <Col className={'border-end'} lg={{size: 6, order: 0}} md={{size: 6, order: 0}}
                                             xs={{size: 6, order: 0}}>
    
                                            <img
                                                src={exampleFace}
                                                alt={'face image example'}
                                                style={{
                                                    display: 'block',
                                                    maxWidth: '100%',
                                                    borderRadius: '20px',
                                                    margin: '0 auto',
                                                    maxHeight: '290px'
                                                }}
                                            />
    
                                        </Col>
    
                                        <Col lg={{size: 6, order: 0}} md={{size: 6, order: 0}} xs={{size: 6, order: 0}}>
    
                                            {imageFace ? (
                                                <img
                                                    id="faceImage"
                                                    src={imageFace}
                                                    alt="face image"
                                                    style={{
                                                        display: 'block',
                                                        maxWidth: '100%',
                                                        borderRadius: '20px',
                                                        margin: '0 auto'
                                                    }}
                                                />
                                            ) : (
                                                <Webcam audio={false}
                                                    screenshotFormat="image/png"
                                                    screenshotQuality={1}
                                                    videoConstraints={videoConstraints}
                                                    ref={webcamRef} style={{
                                                        display: 'block',
                                                        maxWidth: '100%',
                                                        borderRadius: '20px',
                                                        margin: '0 auto',
                                                        transform: 'scaleX(-1)',
                                                    }}
                                                />
                                            )
                                            }
                                        </Col>
                                    </Row>
                                    <Row>
                                        {/* <Col lg={{size: 12, order: 0}} md={{size: 12, order: 0}} xs={{size: 12, order: 0}}>
                                            <video autoPlay playsInline muted></video>
                                        </Col> */}
                                    </Row>
    
    
                                    <Col className={'pt-1'} lg={{size: 12, order: 0}} md={{size: 12, order: 0}}
                                         xs={{size: 12, order: 0}}>
                                        {!imageFace ? (<Button type='button' color='primary'
                                                               onClick={capture}>
                                            <User size={14} className='align-middle me-1'></User>
                                            <span className='align-middle '>
                                        Capturar foto facial
                                    </span>
                                        </Button>) : (<Button type='button' color='primary'
                                                              onClick={() => {
                                                                  setImageFace(null);
                                                                  setImageFaceScore(0)
                                                              }}>
                                            <RefreshCw size={14} className='align-middle me-1'></RefreshCw>
                                            <span className='align-middle '>
                                        Capturar de nuevo
                                    </span>
                                        </Button>)}
                                    </Col>
    
                                    <Col className={'pt-1'} lg={{size: 12, order: 0}} md={{size: 12, order: 0}}
                                         xs={{size: 12, order: 0}}>
    
                                        {imageFace && imageFaceScore > 0 && <Alert color='success'>
                                            <div className='alert-body'>
                                                <CheckCircle size={18}/>
                                                <span className={'ms-1'}>Muy bien, la foto corresponde a un rostro humano con un
                                                    %{imageFaceScore.toFixed(2)} de efectividad</span>
                                            </div>
                                        </Alert>}
    
                                        {imageFace && imageFaceScore <= 0 && <Alert color='danger'>
                                            <div className='alert-body'>
                                                <XCircle size={18}/>
                                                <span className={'ms-1'}>Lo sentimos, la foto no corresponde a un rostro humano</span>
                                            </div>
                                        </Alert>}
    
                                    </Col>
    
    
                                </Col>
                            </Row>
    
                            <hr/>
    
                            <Row>
                                <Col lg={{size: 12, order: 0}} md={{size: 12, order: 0}} xs={{size: 12, order: 0}}
                                     className={'py-1 text-center'}>
    
                                    <span className={'pb-2 fs-4 d-block fw-bold'}>
                                        2. Para tomar la foto, hacer que su documento de identificación cubra por completo el recuadro (por el lado de la cara), y oprima <strong> Capturar documento (cara)</strong></span>
    
    
                                    <Row>
                                        <Col className={'border-end'} lg={{size: 6, order: 0}} md={{size: 6, order: 0}}
                                             xs={{size: 6, order: 0}}>
    
                                            <img
                                                src={exampleFaceDocument}
                                                alt={'face image document example'}
                                                style={{
                                                    display: 'block',
                                                    maxWidth: '100%',
                                                    borderRadius: '20px',
                                                    margin: '0 auto',
                                                    maxHeight: '290px'
                                                }}
                                            />
    
                                        </Col>
    
                                        <Col lg={{size: 6, order: 0}} md={{size: 6, order: 0}} xs={{size: 6, order: 0}}>
    
                                            {imageDocument ? (
                                                <img
                                                    id="documentImage"
                                                    src={imageDocument}
                                                    alt="document image"
                                                    style={{
                                                        display: 'block',
                                                        maxWidth: '100%',
                                                        borderRadius: '20px',
                                                        margin: '0 auto'
                                                    }}
                                                />
                                            ) : <div className={styles.cameraContainer}>
                                                <Webcam audio={false}
                                                        screenshotFormat="image/png"
                                                        videoConstraints={videoConstraints}
                                                        screenshotQuality={1}
                                                        ref={camDocRef} style={{
                                                    display: 'block',
                                                    maxWidth: '100%',
                                                    borderRadius: '20px',
                                                    margin: '0 auto',
                                                    height: '100%',
                                                    transform: 'scaleX(-1)',
                                                }}/>
                                                <div className={styles.overlay}></div>
                                            </div>}
    
                                        </Col>
                                    </Row>
    
    
                                    <Col className={'pt-1'} lg={{size: 12, order: 0}} md={{size: 12, order: 0}}
                                         xs={{size: 12, order: 0}}>
                                        {!imageDocument ? (<Button type='button' color='primary'
                                                                   onClick={captureDocument}>
                                            <CreditCard size={14} className='align-middle me-1'></CreditCard>
                                            <span className='align-middle '>
                                        Capturar documento (cara)
                                    </span>
                                        </Button>) : (<Button type='button' color='primary'
                                                              onClick={() => {
                                                                  setImageDocument(null)
                                                              }}>
                                            <RefreshCw size={14} className='align-middle me-1'></RefreshCw>
                                            <span className='align-middle '>
                                        Capturar de nuevo
                                    </span>
                                        </Button>)}
                                    </Col>
    
                                    <Col className={'pt-1'} lg={{size: 12, order: 0}} md={{size: 12, order: 0}}
                                         xs={{size: 12, order: 0}}>
    
                                        {imageDocument && <Alert color='success'>
                                            <div className='alert-body'>
                                                <CheckCircle size={18}/>
                                                <span
                                                    className={'ms-1'}>Muy bien, la foto es similar al ejemplo dado </span>
                                            </div>
                                        </Alert>}
    
                                        {!imageDocument && <Alert color='danger'>
                                            <div className='alert-body'>
                                                <XCircle size={18}/>
                                                <span className={'ms-1'}>Lo sentimos, la foto no es similar al ejemplo dado</span>
                                            </div>
                                        </Alert>}
    
                                    </Col>
    
    
                                </Col>
    
                            </Row>
    
                            <hr/>
    
                            <Row>
                                <Col lg={{size: 12, order: 0}} md={{size: 12, order: 0}} xs={{size: 12, order: 0}}
                                     className={'py-1 text-center'}>
    
                                    <span className={'pb-2 fs-4 d-block fw-bold'}>
                                        3. Para tomar la foto, hacer que su documento de identificación cubra por completo el recuadro (por el lado reverso), y oprima <strong> Capturar documento (reverso)</strong></span>
    
    
                                    <Row>
                                        <Col className={'border-end'} lg={{size: 6, order: 0}} md={{size: 6, order: 0}}
                                             xs={{size: 6, order: 0}}>
    
                                            <img
                                                src={exampleFaceDocumentBehind}
                                                alt={'face image document example'}
                                                style={{
                                                    display: 'block',
                                                    maxWidth: '100%',
                                                    borderRadius: '20px',
                                                    margin: '0 auto',
                                                    maxHeight: '290px'
                                                }}
                                            />
    
                                        </Col>
    
                                        <Col lg={{size: 6, order: 0}} md={{size: 6, order: 0}} xs={{size: 6, order: 0}}>
    
                                            {imageDocumentBehind ? (
                                                <img
                                                    id="documentImage"
                                                    src={imageDocumentBehind}
                                                    alt="document image"
                                                    style={{
                                                        display: 'block',
                                                        maxWidth: '100%',
                                                        borderRadius: '20px',
                                                        margin: '0 auto'
                                                    }}
                                                />
                                            ) : <div className={styles.cameraContainer}>
                                                <Webcam audio={false}
                                                        screenshotFormat="image/png"
                                                        videoConstraints={videoConstraints}
                                                        screenshotQuality={1}
                                                        ref={camDocBehRef} style={{
                                                    display: 'block',
                                                    maxWidth: '100%',
                                                    borderRadius: '20px',
                                                    margin: '0 auto',
                                                    height: '100%',
                                                    transform: 'scaleX(-1)',
                                                }}/>
                                                <div className={styles.overlay}></div>
                                            </div>}
    
                                        </Col>
                                    </Row>
    
    
                                    <Col className={'pt-1'} lg={{size: 12, order: 0}} md={{size: 12, order: 0}}
                                         xs={{size: 12, order: 0}}>
                                        {!imageDocumentBehind ? (<Button type='button' color='primary'
                                                                         onClick={captureDocumentBehind}>
                                            <CreditCard size={14} className='align-middle me-1'></CreditCard>
                                            <span className='align-middle '>
                                        Capturar documento (reverso)
                                    </span>
                                        </Button>) : (<Button type='button' color='primary'
                                                              onClick={() => {
                                                                  setImageDocumentBehind(null)
                                                              }}>
                                            <RefreshCw size={14} className='align-middle me-1'></RefreshCw>
                                            <span className='align-middle '>
                                        Capturar de nuevo
                                    </span>
                                        </Button>)}
                                    </Col>
    
                                    <Col className={'pt-1'} lg={{size: 12, order: 0}} md={{size: 12, order: 0}}
                                         xs={{size: 12, order: 0}}>
    
                                        {imageDocumentBehind && <Alert color='success'>
                                            <div className='alert-body'>
                                                <CheckCircle size={18}/>
                                                <span
                                                    className={'ms-1'}>Muy bien, la foto es similar al ejemplo dado </span>
                                            </div>
                                        </Alert>}
    
                                        {!imageDocumentBehind && <Alert color='danger'>
                                            <div className='alert-body'>
                                                <XCircle size={18}/>
                                                <span className={'ms-1'}>Lo sentimos, la foto no es similar al ejemplo dado</span>
                                            </div>
                                        </Alert>}
    
                                    </Col>
    
                                </Col>
    
                            </Row>
    
                        </Fragment>)}
    
                        {!loading && !verified && error && <div className='row'>
                            <div className='col-12 px-2 text-center'>
                                <Alert color='danger'>
                                    <div className='alert-body py-3'>
                                        <XCircle size={32}/>
                                        <h3 className='text-danger pt-2'>
                                            Prueba de vida invalida!
                                        </h3>
                                    </div>
                                </Alert>
                            </div>
                        </div>
                        }
    
                        <hr/>
                    </CardBody>
                    <CardFooter className="border-0">
                        <div className='d-flex justify-content-between'>
                            {!error && !verified && <><Button color='primary' className='btn-prev' onClick={() => {
                                setVerified(false);
                                setError(null);
                                stepper.previous()
                            }}>
                                <ArrowLeft size={14} className='align-middle me-sm-25 me-0'></ArrowLeft>
                                <span className='align-middle d-sm-inline-block d-none'>Anterior</span>
                            </Button>
                                <Button type='button' color='primary' className={'btn-next'}
                                        disabled={loading || !imageFace || !imageDocument || !imageDocumentBehind || imageFaceScore <= 0}
                                        onClick={() => verifiedAction()}>
                                    <span className='align-middle'>
                                        Finalizar
                                    </span>
                                </Button></>}
                        </div>
                    </CardFooter>
                </Card>
            </div>
            )}
            {!hasCameraPermission && (
            <CheckPermission
                hasCameraPermission={hasCameraPermission}
                setHasCameraPermission={setHasCameraPermission}
            />)}
        </React.Fragment>
    );
};

export default IdentityRecognition;
